<app-nav-bar></app-nav-bar>
<app-course-header [type]="pageName"></app-course-header>

<ng-container *ngIf="myCourses.length > 0">
  <ng-container *ngFor="let myCourse of myCourses; let i = index">
    <div class="container course_contain_body">
      <div class="course_contain_image">
        <img
          src="{{ myCourse?.Course?.CourseImage }}"
          alt=""
          class="course_image_pic"
        />
      </div>
      <div class="course_contain_text">
        <a
          [routerLink]="[
            '/dashboard/my-lessons/read/user/',
            myCourse?.UserId,
            'course',
            myCourse?.CourseId
          ]"
          [queryParams]="myCourse.inviteFrom && { invited: 'true' }"
        >
          <h3 class="course_contain_heading">
            {{ myCourse?.Course?.CourseTitle }}
          </h3>
        </a>

        <ng-container *ngIf="myCourse?.UserInvitedCourses?.length > 0">
          <div class="user_icon_add23">
            <div class="user_small_pic">
              <img
                class="round"
                [src]="
                  myCourse.User.ProfilePicture || 'assets/images/Group 110.png'
                "
                alt=""
                class="add_indicator_pic1"
              />
              <ng-container
                *ngFor="
                  let user of myCourse?.UserInvitedCourses | slice: 0:6;
                  let i = index
                "
              >
                <img
                  *ngIf="user.Users.length > 0"
                  [ngStyle]="{
                    transform: 'translateX(' + (i + 1) * -20 + 'px)'
                  }"
                  [src]="
                    user.Users[0].ProfilePicture ||
                    'assets/images/Group 110.png'
                  "
                  alt=""
                  class="add_indicator_pic1"
                />
              </ng-container>
            </div>
            <p
              class="counting_sura"
              *ngIf="checkMoreAvailable(myCourse?.UserInvitedCourses?.length)"
            >
              +{{ myCourse?.UserInvitedCourses?.length - 6 }} more
            </p>
          </div>
        </ng-container>
        <p class="star_3day" *ngIf="checkDate(myCourse?.SelectedStartDate)">
          Starts in {{ myCourse?.SelectedStartDate | dateLeft }}({{
            myCourse?.SelectedStartDate | date
          }})
        </p>
        <progressbar
          *ngIf="!checkDate(myCourse?.SelectedStartDate)"
          [value]="
            getProgressBarValue(
              myCourse?.Course?.CourseLessons?.length,
              myCourse?.UserCourseLessonCompletions?.length
            )
          "
          type="success"
          [max]="100"
        ></progressbar>
      </div>
    </div>
  </ng-container>
</ng-container>

<div class="container">
  <div class="flex plan-opt justify-between">
    <div
      routerLink="/dashboard/my-lessons/saved"
      class="start_pan_red45 hover opt-btn"
    >
      Saved Plans
    </div>
    <div
      routerLink="/dashboard/my-lessons"
      class="start_pan_red45 hover opt-btn"
    >
      Ongoing Plans
    </div>
  </div>
</div>
